var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"m-0"},[_vm._t("default",[_vm._v("アップロード")]),_c('div',{staticClass:"d-none"},[_c('input',{attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.change}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }